const userProfileStep = {
  title: "User profile",
  personalInfoTitle: "Personal information",
  personalInfoHint:
    "We need this information so that in case we have additional questions we can reach you if needed.",
  previouslyRegisteredLabel:
    "Check here if you were previously registered in Adobe Digital Experience partner program with a different company name and or email address.",
  mergeHint:
    "This will help us merge your previously earned credentials with your new partner profile",
  personalProfileTitle: "Personal profile",
  personalProfileHint:
    "To get the information you care about most, select the details that best describe you.",
  jobLevelLabel:
    "Which statement best describes your position within your company?",
  jobFunctionLabel:
    "Which statement best describes your job description within your company?",
  primaryRoleLabel:
    "Which statement best describes your interest in the Adobe Digital Experience Partner Program? Select all that apply.",
  termsTitle: "Terms and conditions",
  nextButton: "Next",
  registerButton: "Register",
  /** Default terms URL; onboarding PDF may use getDxpOnboardingTermsPdfUrl in the UI. */
  termsOfUseUrl: "https://www.adobe.com/legal/terms.html",
  termsAgreePrefix:
    "By checking the checkbox, I agree that I have read and accepted the ",
  termsAgreeLinkText: "Terms of Use",
  termsAgreeSuffix: ".",
} as const;

export type UserProfileStepContent = typeof userProfileStep;
export default userProfileStep;
